import React from "react";
import {
    useDisclosure,
    useBreakpointValue,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverArrow,
    PopoverCloseButton,
    PopoverHeader,
    PopoverBody,
    Drawer,
    DrawerOverlay,
    DrawerContent,
    DrawerHeader,
    DrawerCloseButton,
    DrawerBody,
    Flex,
    Portal,
} from "@chakra-ui/react";

interface ResponsivePopoverDrawerProps {
    trigger: React.ReactNode;
    header?: React.ReactNode;
    children: React.ReactNode;
}

const ResponsivePopoverDrawer: React.FC<ResponsivePopoverDrawerProps> = ({
                                                                             trigger,
                                                                             header,
                                                                             children,
                                                                         }) => {
    const {isOpen, onOpen, onClose} = useDisclosure();
    const isMobile = useBreakpointValue({base: true, lg: false});

    if (isMobile) {
        return (
            <>
                <Flex w={"100%"} onClick={onOpen}>{trigger}</Flex>
                <Drawer isOpen={isOpen} onClose={onClose} placement="top">
                    <DrawerOverlay/>
                    <DrawerContent>
                        <DrawerCloseButton/>
                        {header && <DrawerHeader>{header}</DrawerHeader>}
                        <DrawerBody>{children}</DrawerBody>
                    </DrawerContent>
                </Drawer>
            </>
        );
    }

    // Рендер в document.body поверх Modal (не внутрь overflow:hidden контейнера модалки)
    return (
        <Popover
            isOpen={isOpen}
            onOpen={onOpen}
            onClose={onClose}
            placement="auto"
            isLazy
            strategy="fixed"
            gutter={8}
        >
            <PopoverTrigger>
                <span onClick={onOpen}>{trigger}</span>
            </PopoverTrigger>
            <Portal appendToParentPortal={false}>
                <PopoverContent
                    // Modal ~1400; явно выше. rootProps — на positioned wrapper (popper)
                    rootProps={{style: {zIndex: 1600}}}
                    zIndex={1600}
                    w="xs"
                    maxW="calc(100vw - 16px)"
                    maxH="calc(100vh - 16px)"
                    overflowY="auto"
                >
                    <PopoverArrow/>
                    <PopoverCloseButton/>
                    {header && <PopoverHeader>{header}</PopoverHeader>}
                    <PopoverBody>{children}</PopoverBody>
                </PopoverContent>
            </Portal>
        </Popover>
    );
};

export default ResponsivePopoverDrawer;
